import { type ProgramEnterEvent, createProgramEnterEvent } from 'models';
import { useMutation } from 'query';
import { handleAxiosError } from 'ui';
import type { ApiClientResponseError, DefaultResponseErrorDataObject } from 'common/services';
import { enterEvent } from '../../services';
import { parseBigmarkerErrorMessage } from '../../utils';

type Variables = {
  email?: string;
  eventId: string;
  exitUrl?: string;
  firstName?: string;
  invitationToken?: string;
  lastName?: string;
};

const defaultMutateOnError = (error: ApiClientResponseError<DefaultResponseErrorDataObject>) => {
  handleAxiosError(error, parseBigmarkerErrorMessage({ errorMessage: error.response?.data.message ?? '' }));
};

export const useEnterEvent = () =>
  useMutation<ProgramEnterEvent, Variables, ApiClientResponseError<DefaultResponseErrorDataObject>>({
    defaultMutateOnError,
    async mutationFn({ email, eventId, exitUrl, firstName, invitationToken, lastName }: Variables) {
      /* eslint-disable @typescript-eslint/naming-convention -- Start: We missing correct application model in camelCase, we need to fix it */
      const { data } = await enterEvent(eventId, {
        email,
        exit_uri: exitUrl ?? window.location.href,
        first_name: firstName,
        invitation_token: invitationToken,
        last_name: lastName,
      });
      /* eslint-enable @typescript-eslint/naming-convention -- End: We missing correct application model in camelCase, we need to fix it */

      return createProgramEnterEvent(data);
    },
    onSuccess(data) {
      // TODO maybe move this to `onSuccess` of mutation if make sense in future
      window.open(data.enterUrl, '_self');
    },
  });
